export function arrayGet(list, key, obj = null) {
  if (!list || !key) {
    return null
  }

  let listBefore = list
  if (key.includes('.')) {
    let keys = key.split('.')
    for (let j in keys) {
      let next = keys[j]
      list = list[next]

      //si la liste ne contient pas la clé à revoir lorsqu'on aura l'objet = def
      if (list === undefined && obj) {
        list = listBefore[obj][next]
      }
    }
    return list
  } else {
    return list[key]
  }
}
